const usd = (v) => `$${Number(v || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const FinanceCard = ({ fin }) => (
  <div className="rh-card" data-testid="rh-finance-card">
    <div className="rh-title">Procurement & 50/50 mobilization</div>
    <div className="rh-fin">
      <div><span>Procurement materials · 100% at project authorization</span><b data-testid="rh-procurement-total">{usd(fin.procurement_materials_cost_usd)}</b></div>
      <div><span>Initial mobilization fee · 50%</span><b>{usd(fin.initial_mobilization_50_usd)}</b></div>
      <div className="rh-fin__total"><span>Upfront authorization total</span><b data-testid="rh-upfront-total">{usd(fin.upfront_authorization_total_usd)}</b></div>
      <div><span>Remaining mobilization fee · 50%</span><b>{usd(fin.remaining_mobilization_50_usd)}</b></div>
      <div><span>Stabilization fee</span><b>{usd(fin.stabilization_fee_usd)}</b></div>
      <div className="rh-fin__total"><span>Settlement · {fin.settlement_trigger}</span><b data-testid="rh-settlement-total">{usd(fin.post_signoff_settlement_usd)}</b></div>
    </div>
  </div>
);

export const LinesCard = ({ lines }) => (
  <div className="rh-card" data-testid="rh-lines-card">
    <div className="rh-title">Itemized procurement · documented cost, 0% markup</div>
    <div className="rh-lines">
      {lines.map((l, i) => (
        <div key={l.role + i} className="rh-line">
          <span>{l.qty}× {l.description}<em>{l.classification.category}</em></span><b>{usd(l.line_total_usd)}</b>
        </div>
      ))}
    </div>
  </div>
);

export const CompareCard = ({ cmp }) => (
  <div className="rh-card" data-testid="rh-compare-card">
    <div className="rh-title">Moovin Forward LLC vs traditional general contractor</div>
    <div className="rh-cmp">
      <div className="rh-cmp__head"><span>Metric</span><span>Moovin Forward</span><span>Traditional GC</span></div>
      {cmp.rows.map((r) => (
        <div key={r.metric} className="rh-cmp__row"><span>{r.metric}<em>{r.gc_note}</em></span><b>{usd(r.mf_usd)}</b><b className="rh-gc">{usd(r.gc_usd)}</b></div>
      ))}
      <div className="rh-cmp__row rh-cmp__save"><span>Net savings & capital preservation</span><b data-testid="rh-net-savings">{usd(cmp.net_savings_usd)}</b><b /></div>
    </div>
    <p className="rh-note">{cmp.assumptions.note}</p>
  </div>
);

export const ComplianceCard = ({ hub }) => (
  <div className="rh-card" data-testid="rh-compliance-card">
    <div className="rh-title">Section 8 / HUD-VASH habitability · {hub.habitability.certified ? "Certified · tenant intake ready" : "Open items"}</div>
    {hub.habitability.checks.map((c) => <div key={c.label} className={`rh-check rh-check--${c.result.replace(" ", "_")}`}><span>{c.label}</span><b>{c.result}</b></div>)}
    {hub.deficiency_schedule.length > 0 && <div className="rh-title rh-title--sub">NSPIRE correction schedule</div>}
    {hub.deficiency_schedule.map((d) => <div key={d.room + d.item} className={`rh-def rh-def--${d.class}`}>{d.class_label} · {d.room}: {d.item}</div>)}
  </div>
);
